<template>
	<tr>
		<th>
			<p v-html="title"></p>
		</th>
		<td>
			<slot></slot>
		</td>
	</tr>
</template>
<script>
	export default {
		name: 'RegisterRow',
		props: {
			title: {
				type: String,
				required: true,
			},
		},
	};
</script>
<style lang="scss" scoped>
	th {
		width: 200px;
		padding: 1em;
		text-align: center;
		background: #f4f7fa;
		color: #657088;
		border-bottom: 1px solid #ebebed;
		vertical-align: middle;
	}

	td {
		position: relative;
		padding: 1em;
		color: #657088;
		border-bottom: 1px solid #ebebed;
	}
</style>
